/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useCommonApi from "../hooks/common-apis";
import { Modal } from "flowbite-react";
import { Remarkable } from "remarkable";
import wordsCount from "words-count";
import Loader from "./Loader";
import { Tooltip } from "react-tooltip";
import { clog } from "../lib/utils";

const TextEditor = ({
  stringOutput,
  from = "template",
  setstringOutput,
  title,
  content,
  setsuccessFailureMessage,
  setopenSuccessModal,
  setopenFailureModal,
  selectedRow,
  setcloseOpenContent,
  callSaveApi,
  buyerSteps,
  buyerData,
  setbuyerData,
}) => {
  clog(selectedRow, "selected Row");
  const path = window?.location?.pathname;
  const imageRef = useRef(null);
  const [tooltip, setTooltip] = useState(null);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingTimeout = 500; // Set the timeout value in milliseconds (adjust as needed)
  const [savedSelection, setSavedSelection] = useState(null);
  const [linkToolbar, setLinkToolbar] = useState({
    show: false,
    value: "",
    position: { top: 0, left: 0 },
    applyLink: null,
    removeLink: null,
    edit: false,
  });
  const [activeFormats, setActiveFormats] = useState({
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
    link: false,
  });
  const linkButtonRef = useRef(null);
  const linkInputRef = useRef(null);
  const toolbarRef = useRef(null);
  const [notionPublishModal, setNotionPublishModal] = useState(false);
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [notionPublishing, setNotionPublishing] = useState(false);
  const [notionPages, setNotionPages] = useState([]);
  // const checkCurrentFormat = () => {
  //   const selection = window.getSelection();
  //   if (!selection.rangeCount) return;

  //   const range = selection.getRangeAt(0);
  //   const parentElement = range.commonAncestorContainer.parentElement;

  //   // Helper function to check if element or its parents have a style
  //   const hasStyle = (element, style) => {
  //     while (element && element !== contentEditableRef.current) {
  //       switch (style) {
  //         case "bold":
  //           if (window.getComputedStyle(element).fontWeight >= 600) return true;
  //           break;
  //         case "italic":
  //           if (window.getComputedStyle(element).fontStyle === "italic")
  //             return true;
  //           break;
  //         case "underline":
  //           if (
  //             window
  //               .getComputedStyle(element)
  //               .textDecoration.includes("underline")
  //           )
  //             return true;
  //           break;
  //         case "strikethrough":
  //           if (
  //             window
  //               .getComputedStyle(element)
  //               .textDecoration.includes("line-through")
  //           )
  //             return true;
  //           break;
  //         case "link":
  //           if (element.tagName === "A") return true;
  //           break;
  //         default:
  //           break;
  //       }
  //       element = element.parentElement;
  //     }
  //     return false;
  //   };
  //   // Update active formats
  //   // setActiveFormats({
  //   //   bold: hasStyle(parentElement, "bold"),
  //   //   italic: hasStyle(parentElement, "italic"),
  //   //   underline: hasStyle(parentElement, "underline"),
  //   //   strikethrough: hasStyle(parentElement, "strikethrough"),
  //   //   link: hasStyle(parentElement, "link"),
  //   // });
  // };
  const saveSelection = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setSavedSelection(range);
    }
  };

  const restoreSelection = () => {
    if (savedSelection) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(savedSelection);
    }
  };

  // clog(stringOutput, "string out in text editor");
  //   let stringOutput = `**Definition of Artificial Intelligence (AI)**
  //   - AI is a branch of computer science that aims to build machines capable of intelligent behavior.
  //   - It involves the development of algorithms that enable computers to perform tasks that typically require human intelligence.
  // - **Key Concepts in AI**
  //   - *Machine Learning (ML)*
  //     - ML is a subset of AI that allows machines to learn from data without being explicitly programmed.
  //     - It is crucial for enabling AI systems to improve their performance on a task as they are exposed to more data.
  //   - *Neural Networks*
  //     - Neural networks are a type of ML model inspired by the structure of the human brain.
  //     - They are particularly effective for tasks such as image and speech recognition.
  //   - *Deep Learning*
  //     - Deep learning is a subfield of ML that uses neural networks with many layers (deep neural networks).
  //     - It has fueled significant advances in AI, particularly in areas like natural language processing and computer vision.
  //   - *Natural Language Processing (NLP)*
  //     - NLP is the field of AI that focuses on enabling computers to understand, interpret, and generate human language.
  //     - It is essential for applications like chatbots, language translation, and text analysis.
  //   - *Computer Vision*
  //     - Computer vision is the area of AI that enables machines to interpret and understand the visual world.
  //     - It is crucial for tasks such as facial recognition, object detection, and autonomous driving.`;
  const contentEditableRef = useRef(null);
  const selectedContentSettings = JSON.parse(
    localStorage.getItem("selectedContentSettings")
  );
  const documentBodyRef = useRef(null);
  const [openModal, setopenModal] = useState(undefined);
  const [imageUrl, setimageUrl] = useState("");
  const navigate = useNavigate();
  const [rawFile, setrawFile] = useState(null);
  const [previewUrl, setpreviewUrl] = useState(null);
  const [displayChooseFile, setdisplayChooseFile] = useState(true);
  const [imageWH, setimageWH] = useState({
    width: "",
    height: "",
  });
  const [wordsCharactersCount, setwordsCharactersCount] = useState({
    words: 0,
    characters: 0,
  });
  const [totalText, settotalText] = useState("");
  const [selectedContent, setSelectedContent] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [startIndex, setStartIndex] = useState("");
  const [endIndex, setEndIndex] = useState("");
  const [ws, setWs] = useState(null);
  const [loader, setloader] = useState(false);
  const [reWriteWords, setreWriteWords] = useState("");
  const [rewriting, setrewriting] = useState(false);
  const [rewritingClicked, setrewritingClicked] = useState(false);

  const openModalFn = () => {
    // Save the current cursor position
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      setSavedSelection(selection.getRangeAt(0).cloneRange());
    }

    // Open the modal
    setopenModal("dismissible");
  };
  const getDataType = (type) => {
    if (type == "Operations") {
      return "";
    } else if (type == "Sales") {
    } else {
    }
  };
  // Example function of remarkable
  const getRemarkableText = () => {
    // let string=stringOutput?.replaceAll(/\n/g, "<br/>");
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
      langPrefix: "language-",
    });
    const html = md.render(stringOutput || "");
    return html;
  };
  const getWordsCharacters = () => {
    const contentEditableElement = contentEditableRef?.current;
    const content = contentEditableElement?.innerHTML?.trim();

    if (!content) return setwordsCharactersCount({ words: 0, characters: 0 });

    // Use wordsCount to get the number of words
    const words = wordsCount(content);

    // Count characters including spaces
    const characters = content.length;

    setwordsCharactersCount({ words, characters });
  };
  const savedSelectionRef = useRef(null); // Store selection persistently
  const removeHighlight = () => {
    document.querySelectorAll(".temporary-highlight").forEach((el) => {
      const parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });
    // removeEmptyTags();// Remove empty tags after removing highlight//specially written for links
  };

  // const applyStyleSubFn = async (style, value = null, image_id = null) => {
  //   const selection = window.getSelection();
  //   if (!selection.rangeCount) return;

  //   const range = selection.getRangeAt(0);
  //   const selectedText = range.toString();
  //   if (
  //     selection &&
  //     selection.rangeCount > 0 &&
  //     contentEditableRef.current.contains(
  //       selection.getRangeAt(0).commonAncestorContainer
  //     )
  //   ) {
  //     const wrapSelectedText = (element) => {
  //       element.appendChild(document.createTextNode(selectedText));
  //       range.deleteContents();
  //       range.insertNode(element);
  //     };

  //     const createStyledElement = (tag, styles = {}, classNames = []) => {
  //       const element = document.createElement(tag);
  //       Object.assign(element.style, styles);
  //       element.className = classNames.join(" ");
  //       return element;
  //     };

  //     const applyListStyle = (listType) => {
  //       const listElement = document.createElement(listType);
  //       const listItem = document.createElement("li");
  //       listItem.appendChild(document.createTextNode(selectedText));
  //       listElement.appendChild(listItem);
  //       range.deleteContents();
  //       range.insertNode(listElement);
  //     };

  //     switch (style) {
  //       case "bold":
  //       case "italic":
  //       case "underline":
  //         document.execCommand(style, false, null);
  //         break;
  //       case "heading":
  //         const headingClasses = {
  //           h1: "text-5xl font-extrabold dark:text-white",
  //           h2: "text-4xl font-bold dark:text-white",
  //           h3: "text-3xl font-bold dark:text-white",
  //         };
  //         const heading = createStyledElement(value, {}, [
  //           headingClasses[value],
  //         ]);
  //         wrapSelectedText(heading);
  //         break;
  //       case "fontSize":
  //         const fontSizeNode = createStyledElement("span", { fontSize: value });
  //         wrapSelectedText(fontSizeNode);
  //         break;
  //       case "unlist":
  //         applyListStyle("ul");
  //         break;
  //       case "orlist":
  //         applyListStyle("ol");
  //         break;
  //       case "align":
  //         const parentNode = range.commonAncestorContainer.parentNode;
  //         if (parentNode && parentNode.nodeType === Node.ELEMENT_NODE) {
  //           parentNode.style.textAlign = value;
  //         } else {
  //           const alignNode = createStyledElement("div", { textAlign: value });
  //           wrapSelectedText(alignNode);
  //         }
  //         break;
  //       case "normal":
  //         const normalText = document.createTextNode(selectedText);
  //         const parentNodeNormal = range.commonAncestorContainer.parentNode;
  //         if (parentNodeNormal && parentNodeNormal.hasAttribute("className")) {
  //           parentNodeNormal.removeAttribute("className");
  //         }
  //         if (parentNodeNormal && parentNodeNormal.hasAttribute("class")) {
  //           parentNodeNormal.removeAttribute("class");
  //         }
  //         range.deleteContents();
  //         range.insertNode(normalText);
  //         break;
  //       case "image":
  //         const range1 =
  //           selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  //         const imgContainer = createStyledElement("div", {}, [
  //           "relative",
  //           "inline-block",
  //           "m-0",
  //           "text-center",
  //           "flex",
  //           "justify-center",
  //           "items-center",
  //           "image-container",
  //         ]);
  //         imgContainer.setAttribute("data-image-id", image_id);
  //         imgContainer.setAttribute("contenteditable", "false");

  //         const imgElement = createStyledElement("img", {
  //           width:
  //             imageWH.width?.trim() !== ""
  //               ? imageWH.width?.trim() + "px"
  //               : "250px",
  //           height:
  //             imageWH.height?.trim() !== ""
  //               ? imageWH.height?.trim() + "px"
  //               : "250px",
  //           objectFit: "cover",
  //         });
  //         imgElement.src = !image_id ? image_id : imageUrl;
  //         imgElement.className = "block m-auto";

  //         const hoverButtons = createStyledElement("div", {}, [
  //           "hover-buttons",
  //           "absolute",
  //           "inset-0",
  //           "flex",
  //           "items-center",
  //           "justify-center",
  //           "hidden",
  //           "group-hover:flex",
  //         ]);

  //         const createHoverButton = (innerHtml, positionClass, onClick) => {
  //           const button = createStyledElement("div", {}, [
  //             "absolute",
  //             "cursor-pointer",
  //             "bg-black",
  //             "bg-opacity-50",
  //             "text-white",
  //             "p-1",
  //             "rounded-full",
  //             positionClass,
  //           ]);
  //           button.innerHTML = innerHtml;
  //           button.onclick = onClick;
  //           return button;
  //         };

  //         const closeBtn = createHoverButton("x", "top-1 right-1", () => {
  //           let dataImageId = imgContainer.getAttribute("data-image-id");
  //           clog(dataImageId, "data image id");
  //           deleteImage(dataImageId);
  //           imgContainer.remove();
  //         });
  //         const topLeftBtn = createHoverButton(
  //           "&#8593;",
  //           "top-1 left-1",
  //           () => {
  //             const newLine = document.createElement("div");
  //             newLine.innerHTML = "<br>";
  //             imgContainer.parentNode.insertBefore(newLine, imgContainer);
  //             const newRange = document.createRange();
  //             newRange.setStartBefore(imgContainer);
  //             newRange.setEndBefore(imgContainer);
  //             selection.removeAllRanges();
  //             selection.addRange(newRange);
  //           }
  //         );
  //         const bottomRightBtn = createHoverButton(
  //           "&#8595;",
  //           "bottom-1 right-1",
  //           () => {
  //             const newLine = document.createElement("div");
  //             newLine.innerHTML = "<br>";
  //             imgContainer.parentNode.insertBefore(
  //               newLine,
  //               imgContainer.nextSibling
  //             );
  //             const newRange = document.createRange();
  //             newRange.setStartAfter(imgContainer);
  //             newRange.setEndAfter(imgContainer);
  //             selection.removeAllRanges();
  //             selection.addRange(newRange);
  //           }
  //         );

  //         hoverButtons.appendChild(closeBtn);
  //         hoverButtons.appendChild(topLeftBtn);
  //         hoverButtons.appendChild(bottomRightBtn);

  //         imgContainer.appendChild(imgElement);
  //         imgContainer.appendChild(hoverButtons);
  //         imgContainer.classList.add("group");

  //         // Add event listener to prevent deletion with backspace or delete
  //         imgContainer.addEventListener("keydown", (e) => {
  //           if (e.key === "Backspace" || e.key === "Delete") {
  //             e.preventDefault();
  //             const newRange = document.createRange();
  //             const parentDiv = imgContainer.parentNode;
  //             if (e.key === "Backspace") {
  //               newRange.setStartBefore(imgContainer);
  //               newRange.setEndBefore(imgContainer);
  //             } else if (e.key === "Delete") {
  //               newRange.setStartAfter(imgContainer);
  //               newRange.setEndAfter(imgContainer);
  //             }
  //             selection.removeAllRanges();
  //             selection.addRange(newRange);
  //           }
  //         });
  //         range1.deleteContents();
  //         range1.insertNode(imgContainer);

  //         setimageUrl("");
  //         setrawFile(null);
  //         setpreviewUrl(null);
  //         setdisplayChooseFile(false);
  //         setTimeout(() => {
  //           setdisplayChooseFile(true);
  //         }, 10);
  //         setimageWH({
  //           width: "",
  //           height: "",
  //         });
  //         break;
  //       default:
  //         break;
  //     }
  //     if (
  //       style !== "bold" &&
  //       style !== "italic" &&
  //       style !== "underline" &&
  //       style !== "image"
  //     ) {
  //       handleContentChange({
  //         target: {
  //           innerHTML: contentEditableRef.current.innerHTML,
  //         },
  //       });
  //     }
  //     // Reinitialize interact.js for images after inserting
  //     // initializeInteract();
  //   }

  //   contentEditableRef.current.focus();
  // };
  // Function to apply styles like bold, italic, underline, etc.
  const applyStyleSubFn = async (
    style,
    value = null,
    image_id = null,
    createLink = ""
  ) => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const selectedText = range.toString();
    if (selectedText?.trim() === "") return;
    if (
      selection &&
      selection.rangeCount > 0 &&
      contentEditableRef.current.contains(
        selection.getRangeAt(0).commonAncestorContainer
      )
    ) {
      if (style === "createLink") {
        const closestA =
          range.commonAncestorContainer.parentElement.closest("a");
        const existingLink = (() => {
          const range = selection.getRangeAt(0);
          const commonAncestor = range.commonAncestorContainer;

          // Check if selection is inside or contains a link
          const isInsideLink =
            commonAncestor.nodeType === Node.TEXT_NODE
              ? commonAncestor.parentElement.closest("a")
              : commonAncestor.closest("a");

          // If direct link found, return it
          if (isInsideLink) return isInsideLink;

          // Check if selection contains any links
          const tempDiv = document.createElement("div");
          tempDiv.appendChild(range.cloneContents());
          const linksInSelection = tempDiv.getElementsByTagName("a");

          // Return first link found in selection if any
          return linksInSelection.length > 0 ? linksInSelection[0] : null;
        })();
        clog(existingLink, "existing link");
        // return;

        // // Wrap selected text in a temporary span to highlight
        // const tempSpan = document.createElement("span");
        // tempSpan.style.backgroundColor = "lightblue";
        // tempSpan.classList.add("temporary-highlight");
        // tempSpan.appendChild(document.createTextNode(selectedText));
        // range.deleteContents();
        // range.insertNode(tempSpan);

        // const range = selection.getRangeAt(0);
        const tempSpan = document.createElement("span");
        tempSpan.style.backgroundColor = "lightblue";
        tempSpan.classList.add("temporary-highlight");

        // Clone the range contents with all formatting
        const clonedContents = range.cloneContents();
        tempSpan.appendChild(clonedContents);

        // Insert the highlighted content
        range.deleteContents();
        range.insertNode(tempSpan);

        // Save selection
        savedSelectionRef.current = range.cloneRange();
        const rect = range.getBoundingClientRect();
        const contentEditableRect =
          contentEditableRef?.current?.getBoundingClientRect();
        let left = rect?.left;
        if (rect?.left + 306 > contentEditableRect?.right) {
          left = contentEditableRect?.right - 306;
        }
        // const rect = linkButtonRef?.current?.getBoundingClientRect();
        clog(existingLink, closestA, "existing link");
        setLinkToolbar({
          show: true,
          value: existingLink ? existingLink.href : "",
          position: {
            top: rect?.bottom, // Position 5px below selection
            left: left, // Position at the left edge of the selection
          },
          edit: createLink !== "direct" ? true : false,
          applyLink: (url) => {
            if (savedSelectionRef.current) {
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(savedSelectionRef.current);
            }
            removeHighlight(); // Remove highlight after applying link
            document.execCommand("createLink", false, url);
            setLinkToolbar({
              show: false,
              value: "",
              position: {},
              applyLink: null,
              removeLink: null,
              edit: false,
            });
            if (window.getSelection) {
              window.getSelection().removeAllRanges(); // For modern browsers
              setActiveFormats({
                bold: false,
                italic: false,
                underline: false,
                strikethrough: false,
                link: false,
                heading: null,
                paragraph: false,
                unorderedList: false,
                orderedList: false,
                alignment: null,
              });
            }
          },
          removeLink: () => {
            if (savedSelectionRef.current) {
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(savedSelectionRef.current);
            }
            document.execCommand("unlink", false, null);
            removeHighlight(); // Remove highlight after applying link
            setLinkToolbar({
              show: false,
              value: "",
              position: {},
              applyLink: null,
              removeLink: null,
              edit: false,
            });
            setActiveFormats({
              bold: false,
              italic: false,
              underline: false,
              strikethrough: false,
              link: false,
              heading: null,
              paragraph: false,
              unorderedList: false,
              orderedList: false,
              alignment: null,
            });
          },
        });

        return;
      }

      switch (style) {
        case "bold":
        case "italic":
        case "underline":
        case "strikeThrough":
        case "subscript":
        case "superscript":
        case "justifyLeft":
        case "justifyCenter":
        case "justifyRight":
        case "justifyFull":
        case "insertUnorderedList":
        case "insertOrderedList":
          document.execCommand(style, false, null);
          break;
        case "fontSize":
          document.execCommand("fontSize", false, value);
          break;
        case "foreColor":
          document.execCommand("foreColor", false, value);
          break;
        case "hiliteColor":
          document.execCommand("hiliteColor", false, value);
          break;
        case "formatBlock":
          document.execCommand("formatBlock", false, value);
          break;
        case "removeFormat":
          document.execCommand("removeFormat", false, null);
          break;
        case "createLink":
          document.execCommand("createLink", false, value);
          break;
        case "unlink":
          document.execCommand("unlink", false, null);
          break;
        default:
          break;
      }
      handleContentChange({
        target: {
          innerHTML: contentEditableRef.current.innerHTML,
        },
      });
    }
    contentEditableRef.current.focus();
    handleSelectionChange();
  };
  clog(linkToolbar, "link toolbar");
  //applystyle is used to apply styles like bold, italic, underline, etc. to the selected text
  const applyStyle = async (style, value = null) => {
    let image_id = null;
    if (style == "image" && rawFile && previewUrl) {
      await uploadIconFn(style, value)?.data;
    } else {
      applyStyleSubFn(style, value, null);
    }
    setopenModal(undefined);
  };
  const removeEmptyTags = () => {
    contentEditableRef.current.innerHTML =
      contentEditableRef.current.innerHTML.replace(/<a[^>]*>\s*<\/a>/g, "");
  };

  // useEffect(() => {
  //   if (!linkToolbar.show) {
  //     removeHighlight();
  //     // linkToolbar?.applyLink(linkToolbar.value);
  //   } else {
  //     // if (linkToolbar?.edit) {
  //     //   linkInputRef?.current?.focus();
  //     // }
  //   }
  // }, [linkToolbar?.show]);
  // Click outside handler
  // This effect will close the link toolbar when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toolbarRef.current && !toolbarRef.current.contains(event.target)) {
        setLinkToolbar((prev) => ({ ...prev, show: false }));
        if (window.getSelection().rangeCount > 0) {
          window.getSelection().removeAllRanges();
        }
        removeHighlight();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setLinkToolbar]);

  const handleKeyDown = (event) => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const node = range.startContainer;

    // Function to check if the cursor is next to an image
    const isCursorNextToImage = (range) => {
      const startOffset = range.startOffset;
      const endOffset = range.endOffset;
      const textNode = range.startContainer;

      // Check previous sibling
      if (
        startOffset === 0 &&
        textNode.previousSibling &&
        textNode.previousSibling.nodeName === "IMG"
      ) {
        return true;
      }

      // Check next sibling
      if (
        endOffset === textNode.length &&
        textNode.nextSibling &&
        textNode.nextSibling.nodeName === "IMG"
      ) {
        return true;
      }

      return false;
    };

    // Handling backspace and delete keys
    if (
      (event.key === "Backspace" || event.key === "Delete") &&
      isCursorNextToImage(range)
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (!rawFile) {
      setpreviewUrl(null);
      return;
    }
    const objectURL = URL.createObjectURL(rawFile);
    setpreviewUrl(objectURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawFile]);
  useEffect(() => {
    documentBodyRef.current = document.body;
  }, []);

  const DEBOUNCE_DELAY = 300; // Adjust delay as needed

  // useEffect(() => {
  //   let timeoutId = null;

  //   const handleSelection = () => {
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => {
  //       const selection = window.getSelection();
  //       if (
  //         selection &&
  //         selection.rangeCount > 0 &&
  //         contentEditableRef?.current?.contains(
  //           selection.getRangeAt(0).commonAncestorContainer
  //         )
  //       ) {
  //         handleSelectionChange();
  //       }
  //     }, DEBOUNCE_DELAY);
  //   };

  //   document.addEventListener("selectionchange", handleSelection);

  //   return () => {
  //     document.removeEventListener("selectionchange", handleSelection);
  //     clearTimeout(timeoutId);
  //   };
  // }, []);
  // Add scroll event listener in useEffect
  const handleScroll = () => {
    clog("Came inside handle show");
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      setLinkToolbar((prev) => ({
        ...prev,
        position: {
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX,
        },
      }));
    }
  };
  //extractContext function to extract context before and after the selected keyword
  function extractContext(sentence, keywordArray) {
    // const words = sentence.split(" ");
    const words = sentence.split(/[\s\n]+/);
    // clog(words, "words...");
    let keywordIndex = -1;

    // Find the index of the first word of the keyword in the sentence
    for (let i = 0; i <= words.length - keywordArray.length; i++) {
      if (words[i]?.trim() === keywordArray[0]?.trim()) {
        let match = true;
        // Check if the subsequent words match the keyword
        for (let j = 1; j < keywordArray.length; j++) {
          if (words[i + j]?.trim() !== keywordArray[j]?.trim()) {
            match = false;
            break;
          }
        }
        if (match) {
          keywordIndex = i;
          break;
        }
      }
    }
    // clog(keywordIndex,"keywordIndex...")

    let before = "";
    let after = "";
    if (keywordIndex !== -1) {
      const start = Math.max(0, keywordIndex - 5);
      const end = Math.min(
        words.length,
        keywordIndex + keywordArray.length + 6
      );

      before = words.slice(start, keywordIndex).join(" ");
      after = words.slice(keywordIndex + keywordArray.length, end).join(" ");
    }

    return { before, after };
  }

  function handleSelectionChange1() {
    const selection = window.getSelection();
    if (
      selection &&
      selection.rangeCount > 0 &&
      contentEditableRef.current.contains(
        selection.getRangeAt(0).commonAncestorContainer
      )
    ) {
      if (contentEditableRef) {
        const selectedContent = window.getSelection().toString();
        // const stringWithSpaceBeforeNewline =
        // contentEditableRef.current.innerHTML.replace(/(\n+)/g, " $1");
        // const stringWithSpaceBeforeNewline = contentEditableRef.current.innerText.replace(/\n+/g, ' \n');
        const stringWithSpaceBeforeNewline =
          contentEditableRef.current.innerText.replace(/[\s\n]+/g, " \n");
        let startEnd = extractContext(
          stringWithSpaceBeforeNewline,
          selectedContent?.split(" ")
        );
        const startIndex =
          contentEditableRef.current.innerHTML.indexOf(selectedContent);
        const endIndex = startIndex + selectedContent.length;

        clog(selectedContent, "selected content");
        clog(startEnd, "startEnd");
        clog(startIndex, "start index");
        clog(endIndex, "end index");
        setSelectedContent(selectedContent);
        setStart(startEnd.before);
        setEnd(startEnd.after);
        setStartIndex(startIndex);
        setEndIndex(endIndex);
      }
    }
  }
  // function handleSelectionChange() {
  //   const selection = window.getSelection();
  //   if (
  //     selection &&
  //     selection.rangeCount > 0 &&
  //     contentEditableRef.current.contains(
  //       selection.getRangeAt(0).commonAncestorContainer
  //     )
  //   ) {
  //     if (contentEditableRef) {
  //       const selectedContent = window.getSelection().toString();
  //       clog(selectedContent, "selected content");

  //       const fullText = contentEditableRef.current.textContent;
  //       const startIndex = selection.anchorOffset;
  //       const endIndex = startIndex + selectedContent.length;

  //       const wordsBefore = fullText.slice(0, startIndex).split(/\s+/);
  //       const wordsAfter = fullText.slice(endIndex).split(/\s+/);

  //       const maxWordsBefore = wordsBefore.slice(-5).join(" ");
  //       const maxWordsAfter = wordsAfter.slice(0, 5).join(" ");

  //       const startEnd = {
  //         before: maxWordsBefore,
  //         after: maxWordsAfter,
  //       };

  //       clog(startEnd, "startEnd");
  //       clog(startIndex, "start index");
  //       clog(endIndex, "end index");
  //     }
  //   }
  // }
  //handleSelectionChange function to handle selection changes and update the active formats
  const handleSelectionChange = () => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    let parentNode = range.commonAncestorContainer;

    // Traverse up to find the nearest block element
    while (parentNode && parentNode.nodeType !== 1) {
      parentNode = parentNode.parentNode;
    }

    const computedStyle = window.getComputedStyle(parentNode);
    if (parentNode.nodeName === "A") {
      // If no text is selected or selection is collapsed
      if (selection.toString().length === 0 || selection.isCollapsed) {
        // Create new range for the entire anchor tag
        const newRange = document.createRange();
        newRange.selectNode(parentNode);

        // Clear existing selection and add new range
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
      clog(selection, "selection", selection.toString());
      clog(parentNode, "parent node");
      applyStyleSubFn("createLink", null, null, "direct");
    }

    setActiveFormats({
      bold:
        document.queryCommandState("bold") || computedStyle.fontWeight >= 600,
      italic:
        document.queryCommandState("italic") ||
        computedStyle.fontStyle === "italic",
      underline:
        document.queryCommandState("underline") ||
        computedStyle.textDecoration.includes("underline"),
      strikeThrough:
        document.queryCommandState("strikeThrough") ||
        computedStyle.textDecoration.includes("line-through"),
      link: parentNode.nodeName === "A",

      // Detect Headings
      heading: ["H1", "H2", "H3", "H4", "H5", "H6"].includes(
        parentNode.nodeName
      )
        ? parentNode.nodeName
        : null,
      paragraph: parentNode.nodeName === "P",

      // Detect Lists
      unorderedList: parentNode.nodeName === "UL",
      orderedList: parentNode.nodeName === "OL",

      // Detect Alignments
      alignment:
        computedStyle.textAlign === "left"
          ? "left"
          : computedStyle.textAlign === "center"
          ? "center"
          : computedStyle.textAlign === "right"
          ? "right"
          : computedStyle.textAlign === "justify"
          ? "justify"
          : null,
    });
  };
  // Function to upload the image and apply the style
  const uploadIconFn = async (style, value) => {
    try {
      let formdata = new FormData();

      formdata.append("vsn_file", rawFile);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/upload/files/editorimage`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          jwt_token: localStorage.getItem("login_token"),
        },
        timeout: 10000,
        data: formdata,
      });

      if (!response.data.error) {
        applyStyleSubFn(style, value, response.data.file_path);

        return {
          error: false,
          data: response.data.file_path,
        };
      } else {
        return {
          error: true,
          data: response.data.message,
        };
      }
    } catch (error) {
      clog(error);
      return {
        error: true,
        data: error.message,
      };
    }
  };
  const deleteImage = async (dataImageId) => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/delete/upload_file`,
        method: "POST",
        headers: {
          jwt_token: localStorage.getItem("login_token"),
        },
        timeout: 10000,
        data: {
          file_path: dataImageId,
        },
      });

      if (!response.data.error) {
      } else {
      }
    } catch (error) {
      clog(error);
    }
  };

  const postWebsocketDetailsRewrite = () => {
    const selection = window.getSelection();
    const selectedContent = selection.toString().replace(/\s+/g, " ");
    // Get the HTML content of the contentEditable div
    const fullHtml = contentEditableRef.current.innerHTML;

    // Get the start and end index of the selected content in the HTML
    const startIndex = fullHtml.indexOf(selectedContent);
    const endIndex = startIndex + selectedContent.length;
    // clog(startIndex, "startIndex");
    // clog(endIndex, "endIndex");

    // Split the HTML content around the selected content
    const beforeHtml = fullHtml.slice(0, startIndex);
    const afterHtml = fullHtml.slice(endIndex);
    // clog(beforeHtml, "beforeHtml");
    // clog(afterHtml, "afterHtml");
    // Create a temporary container to get the innerText
    const tempContainerBefore = document.createElement("div");
    tempContainerBefore.innerHTML = beforeHtml;
    let beforeText = tempContainerBefore.innerText;
    const tempContainerAfter = document.createElement("div");
    tempContainerAfter.innerHTML = afterHtml;
    let afterText = tempContainerAfter.innerText;

    // Get the text content and split into words
    const beforeWords = beforeText
      .split(/<[^>]*>|&nbsp;|[^\w]+/)
      .filter(Boolean);
    const afterWords = afterText.split(/<[^>]*>|&nbsp;|[^\w]+/).filter(Boolean);

    // Get the max 5 words before and after
    const maxWordsBefore = beforeWords.slice(-5).join(" ");
    const maxWordsAfter = afterWords.slice(0, 5).join(" ");

    if (
      selection &&
      selection.rangeCount > 0 &&
      contentEditableRef.current.contains(
        selection.getRangeAt(0).commonAncestorContainer
      )
    ) {
      if (ws) {
        ws.close(); // Close the existing WebSocket connection if it exists
        setWs(null); // Reset the WebSocket state
      }
      const newWs = new WebSocket(`${process.env.REACT_APP_BASE_URL}/rewrite`);
      setWs(newWs);

      newWs.onopen = function open() {
        setloader(true);
        setreWriteWords("");
        let new_data = {
          START: maxWordsBefore,
          PARA: selection.toString(),
          END: maxWordsAfter,
          model: "model_1",
          token: localStorage.getItem("login_token"),
        };
        setrewriting(true);
        const dataToSend = JSON.stringify(new_data);
        newWs.send(dataToSend);
      };

      newWs.onmessage = function incoming(data) {
        // clog("received", data.data);

        const word = data.data;
        const fullHtml = contentEditableRef.current.innerHTML;

        if (word?.charAt(0) == "{" && word.charAt(word.length - 1) == "}") {
          setloader(false);
          setrewriting(false);
        } else {
          const match = word.match(/START:(.*?)PARA:(.*?)END:/s);

          if (match) {
            setTooltip(null);
            const [, startContent, paraContent] = match;
            // clog("START:", startContent);
            // clog("PARA:", paraContent);
            const trimmedParaContent = paraContent.replace(/\s+$/, ""); // Trim trailing spaces
            const startIndex = fullHtml.indexOf(selection.toString());
            const endIndex = startIndex + selection.toString().length;

            // Log to verify indices and current content
            clog("startIndex:", startIndex);
            clog("endIndex:", endIndex);
            clog("fullHtml:", fullHtml);

            clog(
              fullHtml.slice(0, startIndex),
              "fullHtml.substring(0, startIndex)"
            );
            clog(trimmedParaContent, "trimmedParaContent");
            clog(fullHtml.substring(endIndex), "fullHtml.substring(endIndex)");
            // return;
            contentEditableRef.current.innerHTML =
              fullHtml.slice(0, startIndex) +
              trimmedParaContent +
              fullHtml.substring(endIndex);
            const selectedFile = JSON.parse(
              localStorage.getItem("selected_file")
            );
            let selected_file_data = {
              content_id: selectedFile?.content_id || selectedFile?.id || "",
              space_id: selectedFile?.space_id || "",
              folder_id: selectedFile?.folder_id || "",
            };
            let selectedFileContentSettings = {
              ...selectedFile?.content_settings,
            };
            selectedFileContentSettings["content_title"] =
              selectedFile?.content_title;
            selectedFileContentSettings["content_template"] =
              selectedFile?.content_template;
          }
        }
      };
      newWs.onclose = () => {
        setloader(false);
        setrewriting(false);
        clog("WebSocket connection closed.");
      };

      newWs.onerror = (error) => {
        setloader(false);
        setrewriting(false);
        console.error("WebSocket error:", error);
      };
    }
  };
  const postWebsocketDetailsPlagiarism = async () => {
    const selection = window.getSelection();

    if (
      selection &&
      selection.rangeCount > 0 &&
      contentEditableRef.current.contains(
        selection.getRangeAt(0).commonAncestorContainer
      )
    ) {
      try {
        let response = await axios({
          url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/copydup/search`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            jwt_token: localStorage.getItem("login_token"),
          },
          data: {
            textsearch: selectedContent,
            content_id:
              JSON.parse(localStorage.getItem("selected_file")).content_id ||
              JSON.parse(localStorage.getItem("selected_file")).id,
          },
        });
        clog(response, "response");
        if (!response.data.error) {
        } else {
        }
      } catch (error) {
        if (error?.response?.status == 401) {
          localStorage.removeItem("login_token");
          localStorage.removeItem("login_data");
          navigate("/");
        }
        clog(error);
      }
    }
  };

  useEffect(() => {
    // Cleanup function to clear the timer when the component unmounts
    return () => {
      if (typingTimer) {
        clearTimeout(typingTimer);
      }
    };
  }, [typingTimer]);

  // const handleContentChange = (event) => {
  //   if (from === "knowledgebase") return;
  //   let updatedContent = event.target.innerHTML;
  //   // Remove unwanted text dynamically
  //   updatedContent = updatedContent.replace(
  //     /Written by AI Employee <a .*?>.*?<\/a>/gi,
  //     ""
  //   );
  //   // Remove empty tags (like <p></p>, <div></div>, etc.)
  //   updatedContent = updatedContent.replace(/<(\w+)[^>]*>\s*<\/\1>/g, "");
  //   // getWordsCharacters();
  //   // // Clear the previous timer
  //   if (typingTimer) {
  //     clearTimeout(typingTimer);
  //   }

  //   // Set a new timer to call the save API after typingTimeout milliseconds
  //   const newTypingTimer = setTimeout(() => {
  //     callSaveApi(updatedContent, "content");
  //   }, typingTimeout);

  //   setTypingTimer(newTypingTimer);
  // };
  // Function to handle content changes and save to API
  const handleContentChange = (event) => {
    if (from === "buyer") {
      let buyerDataCopied = {
        ...buyerData,
      };
      if (buyerSteps === 1) {
        buyerDataCopied["business_info"] = event?.target?.innerHTML;
      } else if (buyerSteps === 2) {
        buyerDataCopied["List_of_products_and_services"] =
          event?.target?.innerHTML;
      } else {
        buyerDataCopied["buyer_percona"] = event?.target?.innerHTML;
      }
      setbuyerData(buyerDataCopied);
      return;
    }
    if (from === "knowledgebase") return;
    let updatedContent = event.target.innerHTML;

    // Remove unwanted text dynamically
    updatedContent = updatedContent.replace(
      /Written by AI Employee <a .*?>.*?<\/a>/gi,
      ""
    );

    // Remove empty tags (like <p></p>, <div></div>, etc.)
    updatedContent = updatedContent.replace(/<(\w+)[^>]*>\s*<\/\1>/g, "");

    // Remove <span class="temporary-highlight"> but keep its contents
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = updatedContent;

    tempDiv.querySelectorAll(".temporary-highlight").forEach((span) => {
      const parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    });

    updatedContent = tempDiv.innerHTML;

    // If needed, call word count function
    // getWordsCharacters();

    // Clear the previous timer
    if (typingTimer) {
      clearTimeout(typingTimer);
    }

    // Set a new timer to call the save API after typingTimeout milliseconds
    const newTypingTimer = setTimeout(() => {
      callSaveApi(updatedContent, "content");
    }, typingTimeout);

    setTypingTimer(newTypingTimer);
  };

  const saveContentToApi = async (content) => {
    // Create a temporary element to hold the HTML
    let tempElement = document.createElement("div");
    tempElement.innerHTML = contentEditableRef.current.innerHTML;

    // Get all elements with class 'hover-buttons' and remove them
    let hoverButtons = tempElement.querySelectorAll(".hover-buttons");
    hoverButtons.forEach((button) => button.parentNode.removeChild(button));

    // Get the cleaned HTML
    let cleanedHTML = tempElement.innerHTML;

    // clog(cleanedHTML);

    // clog(contentEditableRef.current.innerHTML, "content...");
    if (from == "chat") {
      return;
    }
    // Call your save API with the updated content
    // clog("Saving to API:", content);
    if (content && content != "") {
      // callUpdateToFileApi(selectedContentSettings, content);
      const selectedFile = JSON.parse(localStorage.getItem("selected_file"));
      let selected_file_data = {
        content_id: selectedFile?.content_id || selectedFile?.id || "",
        space_id: selectedFile?.space_id || "",
        folder_id: selectedFile?.folder_id || "",
      };
      let selectedFileContentSettings = { ...selectedFile?.content_settings };
      selectedFileContentSettings["content_title"] =
        selectedFile?.content_title;
      selectedFileContentSettings["content_template"] =
        selectedFile?.content_template;

      // clog(
      //   selectedFileContentSettings,
      //   "selectedFileContentSettings",
      //   selectedFile,
      //   selected_file_data
      // );
      // setstringOutput(content);
    }
  };
  const [posting, setposting] = useState(false);
  const [postingnotion, setpostingnotion] = useState(false);
  const postWordpressFn = async () => {
    // clog(contentEditableRef?.current?.innerHTML, "contentEditableRef");
    // clog(
    //   {
    //     title: title,
    //     content: contentEditableRef?.current?.innerHTML,
    //     author_id: "", //blank
    //     cms_type: "wordpress",
    //     content_id:selectedRow?.id
    //   },"data"
    // )
    // return;
    setposting(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/blog/post`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          title: title,
          content: contentEditableRef?.current?.innerHTML,
          author_id: "", //blank
          cms_type: "wordpress",
          content_id: selectedRow?.id,
        },
      });
      if (!response.data.error) {
        setsuccessFailureMessage(
          response?.data?.message?.message || response?.data?.message
        );
        setopenSuccessModal("dismissible");
      } else {
        clog(response.data, "response.data");
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(
          response?.data?.message?.message || response?.data?.message
        );
      }
    } catch (error) {
      clog(error);
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(error?.message);
    } finally {
      setposting(false);
    }
  };
  const [notion_access, setnotion_access] = useState(
    JSON.parse(localStorage.getItem("notion_access") || "false")
  );
  const [notionAccessList, setNotionAccessList] = useState([]);
  async function checkNotionAccess() {
    try {
      setpostingnotion(true);
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/notion/access`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });
      // clog(response, "response");
      if (!response.data.error) {
        if (response.data?.access_token) {
          localStorage.setItem("notion_access", JSON.stringify(true));
          setnotion_access(true);
          setNotionAccessList(response.data?.data);
        } else {
          localStorage.setItem("notion_access", JSON.stringify(false));
          setnotion_access(false);
          setNotionAccessList([]);
        }
      } else {
        localStorage.setItem("notion_access", JSON.stringify(false));
        setnotion_access(false);
        setNotionAccessList([]);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      localStorage.setItem("notion_access", JSON.stringify(false));
      setnotion_access(false);
      setNotionAccessList([]);
    } finally {
      setpostingnotion(false);
    }
  }
  // Function to check Notion access and get pages
  const checkNotionAccessAndGetPages = async () => {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/notion/access`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });

      if (!response.data.error && response.data?.access_token) {
        setNotionPages(response.data?.data || []);
        setNotionPublishModal(true);
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage("Please connect Notion first!");
      }
    } catch (error) {
      clog(error);
      setopenFailureModal("dismissible");
      setsuccessFailureMessage("Error checking Notion access");
    }
  };
  // Function to publish to Notion
  const publishToNotion = async () => {
    if (!selectedDatabase) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage("Please select a database!");
      return;
    }

    try {
      setNotionPublishing(true);
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/notion/post_blog`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
          resource_id: selectedDatabase,
          blog_title: title,
          blog_content: contentEditableRef?.current?.innerHTML,
          blog_tags: [],
          content_id: selectedRow?.id,
        },
      });

      if (!response.data.error) {
        setsuccessFailureMessage(
          response.data.message || "Successfully published to Notion!"
        );
        setopenSuccessModal("dismissible");
        setNotionPublishModal(false);
        setSelectedDatabase(null);
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(
          response.data.message || "Failed to publish to Notion"
        );
      }
    } catch (error) {
      clog(error);
      setopenFailureModal("dismissible");
      setsuccessFailureMessage("Error publishing to Notion");
    } finally {
      setNotionPublishing(false);
      //reset all related states
      setNotionPages([]);
      setSelectedDatabase(null);
      setNotionPublishing(false);
    }
  };
  // Function to get words and characters count
  useEffect(() => {
    getWordsCharacters();
    // checkNotionAccess()
  }, []);
  // useeffect to set target="_blank" and rel="noopener noreferrer" for all external links
  useEffect(() => {
    const links = document.querySelectorAll('a[href^="http"]');
    clog("Selected links:", links);
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }, []);
  // Function to update the link toolbar position
  const updateLinkToolbarPosition = () => {
    if (linkToolbar.show && savedSelectionRef.current) {
      const rect = savedSelectionRef.current.getBoundingClientRect();
      const contentEditableRect =
        contentEditableRef?.current?.getBoundingClientRect();

      let left = rect?.left;
      if (rect?.left + 306 > contentEditableRect?.right) {
        left = contentEditableRect?.right - 306;
      }

      setLinkToolbar((prev) => ({
        ...prev,
        position: {
          top: rect.bottom,
          left: left,
        },
      }));
    }
  };

  // Add scroll event listener
  useEffect(() => {
    if (linkToolbar.show) {
      window.addEventListener("scroll", updateLinkToolbarPosition, true);
      return () => {
        window.removeEventListener("scroll", updateLinkToolbarPosition, true);
      };
    }
  }, [linkToolbar.show]);
  clog(activeFormats, "activeFormats");

  return (
    <div className="">
      <div className="bg-white pt-2 px-2">
        <div className="sticky top-0 bg-white z-50">
          {from !== "knowledgebase" && (
            <div className="flex pb-3 items-center justify-between">
              {path !== "/knowledge" && (
                <>
                  <div className="text-[24px] flex items-center">
                    <button
                      className="text-[22px] px-2"
                      onClick={() => {
                        setcloseOpenContent(false);
                      }}
                    >
                      <svg className="icon text-[34px]">
                        <use href="#icon_close"></use>
                      </svg>
                    </button>
                    Editor
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      className="bg-[#097BA9] text-white px-4 py-1 rounded-[10px] hover:bg-[#0A6C93] transition-colors"
                      onClick={checkNotionAccessAndGetPages}
                    >
                      {notionPublishing ? <Loader /> : "Publish to Notion"}
                    </button>
                    <button
                      className="bg-[#097BA9] text-white px-4 py-1 rounded-[10px] hover:bg-[#0A6C93] transition-colors"
                      onClick={postWordpressFn}
                    >
                      {posting ? <Loader /> : "Publish to WordPress"}
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
          {from !== "knowledgebase" && (
            <div className="flex items-center gap-3 bg-gray-100 p-2 border-b border-gray-300 rounded-md">
              {/* Formatting Buttons */}
              <div className="flex items-center gap-2 border-r border-gray-400 pr-3">
                {[
                  { style: "bold", label: "B", tooltip: "Bold" },
                  { style: "italic", label: "I", tooltip: "Italic" },
                  { style: "underline", label: "U", tooltip: "Underline" },
                  {
                    style: "strikeThrough",
                    label: <s>S</s>,
                    tooltip: "Strikethrough",
                  },
                ].map(({ style, label, tooltip }) => (
                  <button
                    key={style}
                    className={`text-[20px] px-3 py-1 rounded-md transition ${
                      activeFormats[style] ? "bg-gray-300" : "hover:bg-gray-200"
                    }`}
                    onClick={() => applyStyle(style, style)}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={tooltip}
                    data-tooltip-place="bottom"
                  >
                    {label}
                  </button>
                ))}
              </div>

              {/* Heading Options */}
              <div className="flex items-center gap-2 border-r border-gray-400 pr-3">
                {["H1", "H2", "H3", "H4", "H5", "H6"].map((h) => (
                  <button
                    key={h}
                    // className={`font-extrabold text-[18px] px-3 py-1 rounded-md hover:bg-gray-200 transition`}
                    className={`font-extrabold text-[18px] px-3 py-1 rounded-md transition ${
                      activeFormats.heading === h
                        ? "bg-gray-300"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => applyStyle("formatBlock", h.toLowerCase())}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={`Heading ${h.replace("H", "")}`}
                    data-tooltip-place="bottom"
                  >
                    {h}
                  </button>
                ))}
                <button
                  className="text-[18px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
                  onClick={() => applyStyle("formatBlock", "p")}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Paragraph"
                  data-tooltip-place="bottom"
                >
                  Normal
                </button>
              </div>

              {/* List Options */}
              <div className="flex items-center gap-3 border-r border-gray-400 pr-3">
                {[
                  {
                    style: "insertUnorderedList",
                    icon: "icon_list",
                    tooltip: "Unordered List",
                  },
                  {
                    style: "insertOrderedList",
                    icon: "icon_order-list",
                    tooltip: "Ordered List",
                  },
                ].map(({ style, icon, tooltip }) => (
                  <button
                    key={style}
                    // className="p-2 rounded-md hover:bg-gray-200 transition"
                    className={`p-2 rounded-md transition ${
                      activeFormats[style] ? "bg-gray-300" : "hover:bg-gray-200"
                    }`}
                    onClick={() => applyStyle(style, style)}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={tooltip}
                    data-tooltip-place="bottom"
                  >
                    <svg className="icon text-[24px]">
                      <use href={`#${icon}`}></use>
                    </svg>
                  </button>
                ))}
              </div>

              {/* Link Button */}
              <div className="">
                <button
                  onClick={() => applyStyle("createLink", "")}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Insert Link"
                  data-tooltip-place="bottom"
                  ref={linkButtonRef}
                  className={`p-2 rounded-md ${
                    linkToolbar.show || activeFormats?.link
                      ? "bg-gray-300"
                      : "hover:bg-gray-200"
                  } transition`}
                >
                  <svg className="icon text-[22px]">
                    <use href="#icon_link"></use>
                  </svg>
                </button>
              </div>

              {/* Alignment Options */}
              <div className="flex items-center gap-3">
                {[
                  {
                    style: "justifyLeft",
                    icon: "icon_left",
                    tooltip: "Left Align",
                    computedStyle: "left",
                  },
                  {
                    style: "justifyCenter",
                    icon: "icon_center",
                    tooltip: "Center Align",
                    computedStyle: "center",
                  },
                  {
                    style: "justifyRight",
                    icon: "icon_right",
                    tooltip: "Right Align",
                    computedStyle: "right",
                  },
                  {
                    style: "justifyFull",
                    icon: "icon_justify",
                    tooltip: "Justify Text",
                    computedStyle: "justify",
                  },
                ].map(({ style, icon, tooltip, computedStyle }) => (
                  <button
                    key={style}
                    // className="p-2 rounded-md hover:bg-gray-200 transition"
                    className={`p-2 rounded-md transition ${
                      activeFormats.alignment === computedStyle
                        ? "bg-gray-300"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => applyStyle(style, style)}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={tooltip}
                    data-tooltip-place="bottom"
                  >
                    <svg className="icon text-[22px]">
                      <use href={`#${icon}`}></use>
                    </svg>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        {from === "knowledgebase" ? (
          <div
            style={{
              backgroundColor: "#fff",
              minHeight: "400px", // More height like a page
              // maxWidth: "800px", // Prevents stretching too wide
              // margin: "40px auto", // Centers the editor
              padding: "20px",
              fontSize: "16px",
              // lineHeight: "1.6",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Adds a subtle shadow
              outline: "none",
            }}
          >
            {stringOutput}
          </div>
        ) : (
          <div className="relative">
            <div
              ref={contentEditableRef}
              contentEditable={true}
              style={{
                backgroundColor: "#fff",
                minHeight: "400px", // More height like a page
                // maxWidth: "800px", // Prevents stretching too wide
                // margin: "40px auto", // Centers the editor
                padding: "20px",
                fontSize: "16px",
                // lineHeight: "1.6",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Adds a subtle shadow
                outline: "none",
              }}
              // onSelect={() => {
              //   setLinkToolbar({
              //     show: false,
              //     value: "",
              //     position: {},
              //     applyLink: null,
              //     removeLink: null,
              //     edit: false,
              //   });
              // }}
              onInput={handleContentChange}
              onMouseUp={handleSelectionChange}
              onKeyUp={handleSelectionChange}
              className="text-[#333] mx-0.5 text-editor focus:outline-none"
              dangerouslySetInnerHTML={{ __html: getRemarkableText() }}
            />
            {/* Link Toolbar */}
            {/* {linkToolbar.show && (
              <div
                onClick={(e) => clog(e.target.offsetWidth)}
                className="fixed bg-white shadow-md p-2 border rounded-md flex items-center space-x-2"
                style={{
                  position: "fixed",
                  top: `${linkToolbar.position.top}px`,
                  left: `${linkToolbar.position.left}px`,
                  transform: "translateY(0)",
                  transition: "top 0.1s ease",
                }}
              >
                <textarea
                  ref={linkInputRef}
                  type="text"
                  className="border p-1 text-sm rounded"
                  placeholder="Enter URL"
                  value={linkToolbar.value}
                  onChange={(e) =>
                    setLinkToolbar((prev) => ({
                      ...prev,
                      value: e.target.value,
                    }))
                  }
                />
                <button
                  className="bg-blue-500 hover:bg-blue-600 text-white px-1 py-1 rounded-md text-sm"
                  onClick={() => {
                    linkToolbar.applyLink(linkToolbar.value);
                  }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Apply Link"
                  data-tooltip-place="bottom"
                >
                  <svg className="icon text-[24px]">
                    <use href="#icon_apply"></use>
                  </svg>
                </button>
                <button
                  className="bg-red-500 hover:bg-red-600 text-white px-1 py-1 rounded-md text-sm"
                  onClick={() => {
                    linkToolbar.removeLink();
                  }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Remove Link"
                  data-tooltip-place="bottom"
                >
                  <svg className="icon text-[24px]">
                    <use href="#icon_remove"></use>
                  </svg>
                </button>
              </div>
            )} */}
            {linkToolbar.show && (
              <div
                onClick={(e) => clog(e.target.offsetWidth)}
                className="fixed bg-white shadow-md p-2 border rounded-md flex items-center space-x-2"
                style={{
                  position: "fixed",
                  top: `${linkToolbar.position.top}px`,
                  left: `${linkToolbar.position.left}px`,
                  transform: "translateY(0)",
                  transition: "top 0.1s ease",
                }}
                ref={toolbarRef}
              >
                {linkToolbar.edit ? (
                  // Edit Mode: Show input field and buttons
                  <div className="flex items-center space-x-2 w-65">
                    <textarea
                      ref={linkInputRef}
                      type="text"
                      className="border p-1 text-sm rounded w-52"
                      placeholder="Enter URL"
                      value={linkToolbar.value}
                      onChange={(e) =>
                        setLinkToolbar((prev) => ({
                          ...prev,
                          value: e.target.value,
                        }))
                      }
                    />
                    <div className="flex space-x-1">
                      <button
                        className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded-md text-sm flex items-center"
                        onClick={() => {
                          linkToolbar.applyLink(linkToolbar.value);
                        }}
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Apply Link"
                        data-tooltip-place="bottom"
                      >
                        <svg className="icon text-[18px]">
                          <use href="#icon_apply"></use>
                        </svg>
                      </button>
                      <button
                        className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-md text-sm flex items-center"
                        onClick={() => {
                          linkToolbar.removeLink();
                        }}
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Remove Link"
                        data-tooltip-place="bottom"
                      >
                        <svg className="icon text-[18px]">
                          <use href="#icon_remove"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                ) : (
                  // View Mode: Show link with edit button
                  <div className="flex items-center space-x-2 w-65">
                    <a
                      href={linkToolbar.value}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline text-sm break-all w-52"
                    >
                      {linkToolbar.value}
                    </a>
                    <button
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded-md text-sm flex items-center"
                      onClick={() => {
                        setLinkToolbar((prev) => ({ ...prev, edit: true }));
                      }}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="Edit Link"
                      data-tooltip-place="bottom"
                    >
                      <svg className="icon text-[18px]">
                        <use href="#icon_edit"></use>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* {from !== "knowledgebase" && (
        <div className="flex justify-end w-full mt-1">
          <div className="text-editor-footer-count flex space-x-4">
            <div>
              <span className="font-bold">Words:</span>{" "}
              {wordsCharactersCount.words}
            </div>
            <div>
              <span className="font-bold">Characters:</span>{" "}
              {wordsCharactersCount.characters}
            </div>
          </div>
        </div>
      )} */}

      <Modal
        root={documentBodyRef?.current}
        dismissible
        show={openModal === "dismissible"}
        size="lg"
        onClose={() => setopenModal(undefined)}
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">Insert/Edit Image</h6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="pb-3 pt-4">
            <label htmlFor="file">Image url</label>
            <input
              type="text"
              className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
              placeholder="Image url"
              value={imageUrl}
              onChange={(e) => {
                setimageUrl(e.target.value);
                imageRef.current.value = null;
                if (rawFile) {
                  setrawFile(null);
                  setpreviewUrl(null);
                  imageRef.current.value = null;
                  setdisplayChooseFile(false);
                  setTimeout(() => {
                    setdisplayChooseFile(true);
                  }, 10);
                }
              }}
            />
          </div>
          <div className="text-center pb-3">or</div>
          <div className="pb-3">
            <label htmlFor="file">Upload From Local</label>
            <input
              type="file"
              id="uploaadfile"
              name="file"
              ref={imageRef}
              className="mt-1 w-full rounded-full bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
              placeholder="Upload From Local"
              accept="image/png, image/jpeg"
              onChange={(e) => {
                setimageUrl("");
                setrawFile(e.target.files[0]);
              }}
            />
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="file">Width (in px)</label>
              <input
                type="text"
                className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
                placeholder="Width"
                value={imageWH?.width}
                onChange={(e) =>
                  setimageWH({
                    ...imageWH,
                    width: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label htmlFor="file">Height (in px)</label>
              <input
                type="text"
                className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
                placeholder="Height"
                value={imageWH?.height}
                onChange={(e) =>
                  setimageWH({
                    ...imageWH,
                    height: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="pt-4 flex justify-end">
            <button
              type="button"
              className="flex w-[130px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#ed1512] text-white  hover:from-[#9d3742] hover:to-[#1A71A7] me-6"
              onClick={() => {
                contentEditableRef.current.focus();
                setopenModal(undefined);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="flex w-[130px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              onClick={() => {
                if (imageRef.current) {
                  imageRef.current.value = null; // Clear the input field
                }
                setimageUrl("");
                setpreviewUrl(null);
                setrawFile(null);
                restoreSelection(); // Restore the saved selection
                contentEditableRef.current.focus();
                applyStyle("image");
              }}
              disabled={imageUrl == "" && !previewUrl}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        root={documentBodyRef?.current}
        dismissible
        show={notionPublishModal}
        size="lg"
        onClose={() => {
          setNotionPublishModal(false);
          //reset all related states
          setNotionPages([]);
          setSelectedDatabase(null);
          setNotionPublishing(false);
        }}
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">Select Notion Database</h6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="max-h-[400px] overflow-y-auto">
            {notionPages
              .filter((page) => !page.parent_id)
              .map((parentPage) => (
                <div key={parentPage.id} className="mb-4">
                  <div className="font-semibold text-lg">
                    • {parentPage.title}
                  </div>
                  <div className="ml-6">
                    {notionPages
                      .filter(
                        (childPage) =>
                          childPage.parent_id === parentPage.page_id
                      )
                      .map((childPage) => (
                        <div
                          key={childPage.id}
                          className="flex items-center mt-2"
                        >
                          <input
                            type="radio"
                            id={childPage.page_id}
                            name="notionDatabase"
                            value={childPage.page_id}
                            checked={selectedDatabase === childPage.page_id}
                            onChange={(e) =>
                              setSelectedDatabase(e.target.value)
                            }
                            className="mr-2"
                          />
                          <label htmlFor={childPage.page_id}>
                            {childPage.title}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
          </div>

          <div className="mt-4 flex justify-end">
            <button
              type="button"
              className="px-4 py-2 mr-2 rounded-md bg-gray-200 text-gray-800"
              onClick={() => {
                setNotionPublishModal(false);
                setNotionPublishing(false);
                //reset all related states
                setNotionPages([]);
                setSelectedDatabase(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-4 py-2 rounded-md bg-blue-600 text-white disabled:opacity-50"
              onClick={publishToNotion}
              disabled={!selectedDatabase || notionPublishing}
            >
              {notionPublishing ? <Loader /> : "Publish"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Tooltip
        id="my-tooltip"
        place="bottom"
        delayShow={100}
        className="react-tooltip"
      />
    </div>
  );
};

export default TextEditor;
